export const getAttributions = (layers) => {
    return [
        ...new Set(layers
            .filter((layer) => layer.layerOptions.visible && layer.sourceOptions.attributions)
            .map((layer) => layer.sourceOptions.attributions)
            .flat()),
    ];
};
//# sourceMappingURL=utils.js.map